import React from 'react';
import { Spin } from 'antd';

const TYPE_COLORS = ['#00A8FF', '#FEB019', '#FF4560', '#775DD0', '#00E396', '#FF66C3', '#4bc0c8', '#ff9f40'];

const formatPercentage = (percentage) => {
    if (typeof percentage === 'number' && !isNaN(percentage)) {
        return `${percentage.toFixed(2)}%`;
    }
    return '0.00%';
};

const Type = ({ analyticsData, loading, onFilterChange, activeFilter }) => {

    const alertsByType = analyticsData.alerts_by_type || [];

    const handleButtonClick = (alertType) => {
        if (activeFilter === alertType) {
            onFilterChange(''); // Clear filter
        } else {
            onFilterChange(alertType); // Set new filter
        }
    };

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '250px',
                    width: '100%',
                }}
            >
                <Spin size="large" tip="Loading types..."/>
            </div>
        );
    }

    const itemsPerRow = 4;
    const buttonGroups = [];

    for (let i = 0; i < alertsByType.length; i += itemsPerRow) {
        buttonGroups.push(alertsByType.slice(i, i + itemsPerRow));
    }

    return (
        <>
            <div className="row g-5">
                <div className="col-md-4">
                    <p className="fs-4 fw-bold mb-7">Alerts by Type</p>
                    <div className="d-flex flex-column content-justify-center w-100">
                        {alertsByType.length > 0 ? (
                            alertsByType.map((item, index) => (
                                <div key={item.type} className="d-flex fs-6 fw-semibold align-items-center mb-4">
                                    <div
                                        className="bullet w-6px h-6px rounded-2 me-3"
                                        style={{ backgroundColor: TYPE_COLORS[index % TYPE_COLORS.length] }}
                                    />
                                    <div className="text-gray-800 flex-grow-1 me-4 ">{item.type}</div>
                                    <div className="fw-semibold fs-6 text-gray-700 text-xxl-end me-4">
                                        {formatPercentage(item.percentage)}
                                    </div>
                                    <div className="fw-bolder fs-5 text-gray-800 text-xxl-end min-w-100px ">
                                        {item.count}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className='text-gray-500'>No alert type data available.</div>
                        )}
                    </div>
                </div>

                <div className="col-md-7 ms-auto ">
                    <p className="fs-4 fw-bold mb-5">Alert Type Filters</p>
                    {alertsByType.length > 0 ? (
                        buttonGroups.map((group, groupIndex) => (
                            <div
                                key={`group-${groupIndex}`}
                                className="btn-tags d-flex flex-wrap gap-3 mb-7"
                            >
                                {group.map((item, index) => (
                                    <button
                                        key={`tag-${item.type}`}
                                        className={`btn ${activeFilter === item.type ? 'btn-info' : 'btn-light-info'} fs-7 fw-bold`}
                                        onClick={() => handleButtonClick(item.type)}
                                    >
                                        {item.type} <span>{item.count}</span>
                                    </button>
                                ))}
                            </div>
                        ))
                    ) : (
                        <div className='text-gray-500'>No types to display as filters.</div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Type;